<template>
	<section>
		<router-view></router-view>
	</section>
</template>

<script>
export default {
	data: () => ({}),

	methods: {},
};
</script>

<style></style>
